export default {
  // reset password request
  'Back to login page': 'Back to login page',
  'Reset password': 'Reset password',
  'Enter the email address associated with your account and we’ll send you a link to reset your password.':
    'Enter the email address associated with your account and we’ll send you a link to reset your password.',
  Confirm: 'Confirm',
  // change password form
  'Change password': 'Change password',
  'New password': 'New password',
  'Confirm new password': 'Confirm new password',
  // Check email
  'Check your email': 'Check your email',
  'We have sent a password recover instructions to your email address.':
    'We have sent a password recover instructions to your email address.',
  'Try again': 'Try again',
  'Did not receive the email?': 'Did not receive the email?',
  // reset password fail
  'Oops!': 'Oops!',
  'Sorry, looks like the password recovery link has expired. Please try again.':
    'Sorry, looks like the password recovery link has expired. Please try again.',
  'Something went wrong. Please try again.': 'Something went wrong. Please try again.',
  // reset password success
  'Success!': 'Success!',
  'Your password has been updated. Now you can log in using new password.':
    'Your password has been updated. Now you can log in using new password.',
  'Log in': 'Log in',
  'I am a Business Representative': 'I am a Business Representative',
  'Log in as a company': 'Log in as a company',
  'I am a Wallet User': 'I am a Wallet User',
  'Log in with the wallet app': 'Log in with the wallet app',
  'Your password has been updated. Now you can select the preferred login option and log in with your new password.':
    'Your password has been updated. Now you can select the preferred login option and log in with your new password.',
};
